import styles from './SearchLoader.module.scss';

export default function SearchLoader() {
  return <div className={styles['search-loader']}>Loading ...</div>;
}
